import React, { useContext, useState } from "react";
import Navbar from "../../../../common/layout/Navbar";
import { empType, LicenseTypes } from "../../../../../utils/Enum.types";
import List, { VendorListPageFor } from "./List";
import Table from "./Table";
import { AppProvider } from "../../maps/context/context";
import { Tab, Tabs } from "@mui/material";
import { a11yProps, TabPanel } from "../../../../../styles/Tabs";
import SignalsTable from "./SignalsTable";
import { AppContext } from "../../../../../context/context";

const VendorWiseIndex = () => {
  const [value, setValue] = useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const { state } = useContext(AppContext);

  const showNavbar =
    state.empSubType === empType.JCP ||
    state.empSubType === empType.PMU ||
    state.empSubType === empType.VENDOR_MANAGER ||
    state.empSubType === empType.HELP_DESK;
  return (
    <AppProvider>
      {showNavbar ? (
        <Navbar NavType={LicenseTypes.DASHBOARD} />
      ) : (
        <Navbar NavType={LicenseTypes.COMPANY} />
      )}
      <div className="asset-reports">
        {state.empSubType !== empType.VENDOR_MANAGER && (
          <div className="asset-reports__left">
            <List pageType={VendorListPageFor.VENDOR_WISE} />
          </div>
        )}
        <div className="asset-reports__right">
          <div className="asset-reports__right--tabs">
            <Tabs value={value} onChange={handleChange}>
              <Tab value={0} {...a11yProps(0)} label="Assets" />
              <Tab value={1} {...a11yProps(1)} label="Signals" />
            </Tabs>
          </div>
          <div className="asset-reports__right--tabpanel">
            <TabPanel value={value} index={0}>
              <Table />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <SignalsTable pageType={VendorListPageFor.VENDOR_WISE} />
            </TabPanel>
          </div>
        </div>
      </div>
    </AppProvider>
  );
};

export default VendorWiseIndex;
